var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.667C3.55228 13.667 4 14.1147 4 14.667V18.2457L9 19.6743V17C9 16.4477 9.44772 16 10 16C10.5523 16 11 16.4477 11 17V21C11 21.3138 10.8527 21.6094 10.6022 21.7983C10.3517 21.9873 10.027 22.0477 9.72528 21.9615L2.72528 19.9615C2.29598 19.8389 2 19.4465 2 19V14.667C2 14.1147 2.44772 13.667 3 13.667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5847 2.18877C16.8455 2.37672 17 2.67856 17 3.00001V19C17 19.3215 16.8455 19.6233 16.5847 19.8113C16.3239 19.9992 15.9887 20.0503 15.6838 19.9487L0.683772 14.9487C0.27543 14.8126 0 14.4304 0 14V8.00001C0 7.56958 0.27543 7.18744 0.683772 7.05132L15.6838 2.05132C15.9887 1.94967 16.3239 2.00081 16.5847 2.18877ZM2 8.72077V13.2792L15 17.6126V4.38743L2 8.72077Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11C20 10.4477 20.4477 10 21 10H23C23.5523 10 24 10.4477 24 11C24 11.5523 23.5523 12 23 12H21C20.4477 12 20 11.5523 20 11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3619 4.99302C22.6419 5.46905 22.483 6.08195 22.007 6.36197L20.307 7.36197C19.831 7.64199 19.218 7.48309 18.938 7.00706C18.658 6.53102 18.8169 5.91812 19.2929 5.6381L20.9929 4.6381C21.469 4.35808 22.0819 4.51698 22.3619 4.99302Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.938 14.993C19.218 14.517 19.831 14.3581 20.307 14.6381L22.007 15.6381C22.483 15.9181 22.6419 16.531 22.3619 17.0071C22.0819 17.4831 21.469 17.642 20.9929 17.362L19.2929 16.362C18.8169 16.082 18.658 15.4691 18.938 14.993Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.3312a7c63a02b293180e130be3808c94.svg";
export { ForwardRef as ReactComponent };